import React from "react";
import { useParams } from "react-router-dom";
import { CampaignEmailTemplate } from "./CampaignEmailTemplate";
import { useQueryParam } from "helpers/queryParam/useQueryParam";
import { useTranslation } from "react-i18next";

export const CampaignEmailTemplatePage: React.FC = () => {
  const { t: translate } = useTranslation("email_marketing");
  const { campaignUid } = useParams<{ campaignUid: string }>();
  const [emsUserToken] = useQueryParam("ems_user_token");

  if (!campaignUid) {
    return <div>{translate("campaign.email_template.wrong_url")}</div>;
  }
  return (
    <CampaignEmailTemplate
      campaignUid={campaignUid}
      emsUserToken={emsUserToken}
    />
  );
};
